import React, { useState, useEffect } from "react";
import UserHeader from "./UserHeader";
import { Link } from "react-router-dom";
import { getUserSettngs } from "../../Utils/userFunctions";
let UserMyProfile = () => {
  const [dataUser, setDataUser] = useState("");
  useEffect(() => {
    UserDetails();
  }, []);

  const UserDetails = async () => {
    const response = await getUserSettngs();
    if (response.status === "success") {
      setDataUser(response.data[0]);
    } else {
      setDataUser("");
    }
  };
  return (
    <div>
      <UserHeader />
      <div className="container">
        <div className="row mt-4">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="card vd-card">
              <div className="card-header">
                <div className="d-flex align-items-center">
                  <div className="mr-auto">
                    <h4 className="card-title">Profile</h4>
                  </div>

                  <div className="edit-profile-btn">
                    <Link className="edit-profile" to="/UserEditProfile">
                      Edit profile
                    </Link>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="profile-content-info">
                  <div className="profile-heading">
                    <h3>Personal Information</h3>
                  </div>
                  <ul className="profile-other-list">
                    <li>
                      <span className="pd-left">First Name:</span>

                      <span className="pd-right">{dataUser.first_name}</span>
                    </li>

                    <li>
                      <span className="pd-left">Last Name:</span>

                      <span className="pd-right">{dataUser.last_name}</span>
                    </li>

                    <li>
                      <span className="pd-left">Email Id</span>

                      <span className="pd-right">{dataUser.email}</span>
                    </li>

                    <li>
                      <span className="pd-left">Phone Number</span>

                      <span className="pd-right">{dataUser.contact}</span>
                    </li>
                  </ul>
                </div>

                <div className="profile-content-info">
                  <div className="profile-heading">
                    <h3>Company Information</h3>
                  </div>

                  <ul className="profile-other-list">
                    <li>
                      <span className="pd-left">Company Name:</span>

                      <span className="pd-right">{dataUser.company_name}</span>
                    </li>

                    <li>
                      <span className="pd-left">Address 1:</span>

                      <span className="pd-right">{dataUser.address1}</span>
                    </li>

                    <li>
                      <span className="pd-left">Address 2:</span>

                      <span className="pd-right">{dataUser.address2}</span>
                    </li>

                    <li>
                      <span className="pd-left">City:</span>

                      <span className="pd-right">{dataUser.city}</span>
                    </li>

                    <li>
                      <span className="pd-left">State:</span>

                      <span className="pd-right">{dataUser.state_name}</span>
                    </li>

                    <li>
                      <span className="pd-left">Zip Code</span>

                      <span className="pd-right">{dataUser.zip_code}</span>
                    </li>

                    <li>
                      <span className="pd-left">Country</span>

                      <span className="pd-right">{dataUser.country_name}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserMyProfile;
